import { customFormatMoney, toFixed } from 'services/accountingServices'
import Vue from 'vue'

const decimalFormat = function(numb = 0) {
	return customFormatMoney(toFixed(numb), { symbol: '', decimal: ',', thousand: '.' })
}

Vue.filter('decimalFormat', decimalFormat)
